import { History, Home } from 'lucide-react'

import type { HomeWidgetDefinition } from '@/lib/home-widgets'

import { WelcomeWidget } from './features/welcome/welcome-widget'
import { RecentlyVisitedWidget } from './features/recently-visited/recently-visited-widget'

export const hierarchyHomeWidgets = [
  {
    id: 'hierarchy.welcome', name: 'Welcome', description: 'An introduction to the selected entity.',
    icon: Home, order: 10,
    defaultSize: { columns: 2, rows: 2 }, minimumSize: { columns: 1, rows: 2 },
    component: WelcomeWidget,
  },
  {
    id: 'hierarchy.recently-visited', name: 'Recently visited', description: 'Pages you recently visited in this entity.',
    icon: History, order: 20,
    defaultSize: { columns: 2, rows: 2 }, minimumSize: { columns: 1, rows: 2 },
    component: RecentlyVisitedWidget,
  },
] satisfies readonly HomeWidgetDefinition[]
